module.exports = __webpack_public_path__ + "img/red-3-diamond-open.24f06cad.svg";